import { Injectable } from '@angular/core';
import { DetailedItem } from '../detailed-item';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class DetailedDropdownSuggestedService {

  _items = new Subject<DetailedItem[]>();
  items: Observable<any>  = this._items.asObservable();

  updateDropdown (items: DetailedItem[]) {
    this._items.next(items);
  }
}
